export interface SelectOptionDisplay {
  id: unknown;
  displayName: string;
}

export const getOptionDisplayName = (
  options: SelectOptionDisplay[],
  id: unknown,
): string | undefined => {
  return options.find((option) => option.id === id)?.displayName;
};

export const formatMultipleSelectRenderValue = ({
  value,
  options,
  emptyValue,
}: {
  value: unknown;
  options: SelectOptionDisplay[];
  emptyValue: string | undefined;
}): string => {
  const selected = Array.isArray(value) ? value : [];

  if (selected.length === 0) {
    return emptyValue ?? '';
  }

  return selected
    .map((v) => getOptionDisplayName(options, v) ?? String(v))
    .join(', ');
};
